                                                                                                                                    //CSS ENTRY POINT
//import '../scss/main.scss';
//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');

//=====================================
//FANCY BOX
//=====================================
import { Fancybox } from "@fancyapps/ui";
window.Fancybox = Fancybox;

//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// // Or import only needed plugins
// import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';

// // Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
// ※Facyboxをインポートすると圧縮版のnpmコンパイルで失敗するため
// webpack.config.jsのwebpack-fix-style-only-entriesを無効にした
//=====================================
// Popper
// require('@popperjs/core');
// require('bootstrap');
// import * as Popper from "@popperjs/core"
//=====================================
window.Popper = require('@popperjs/core');

//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

//=====================================
//SplitType
//=====================================
const SplitType = require('split-type').default;
window.SplitType = SplitType;
//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade, Scrollbar } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Scrollbar]);
window.Swiper = Swiper;

//=====================================
//Muuri
//=====================================
const Muuri = require('muuri').default;
window.Muuri = Muuri;

//Swiper Slide 4
function initializeSwiper(containerId, menuId) {
  var menuSwiper = new Swiper(menuId, {
    slidesPerView: 4,
    spaceBetween: 0,
    allowSlideNext: false,
    allowSlidePrev: false,
  });
  var mainSwiper = new Swiper(containerId, {
    loop: true,
    spaceBetween: 0,
    clickable: true,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
  });
}

//=====================================
// JQUERY PAGE LOADED
//=====================================
$(function(){

  initializeSwiper("#box-gallery1", "#box-gallery1_menu");
  initializeSwiper("#box-gallery2", "#box-gallery2_menu");
//=====================================
// JSwiper Slide 4
//=====================================

  $('.digit').each(function() {
    var originalNumber = $(this).text();
    var formattedNumber = numberWithCommas(originalNumber);
    $(this).text(formattedNumber);
  });
  function numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

//FAQ ETC
  // $('[data-bs-toggle="popover"]').popover();
  // $('[data-bs-toggle="tooltip"]').tooltip();
//FAQ ETC
  $(".lst-slidedown").find("li").on("click", function(){
    if ($(this).hasClass("shown")) {
      $(this).removeClass("shown");
    } else {
      $(this).addClass("shown");
    }
  });

// const popover = new bootstrap.Popover('.popover-dismiss', {
//   trigger: 'focus'
// })
// $('[data-fancybox="gallery"]').fancybox({});
// $('[data-fancybox="gallery"]').fancybox({
//   // 任意の設定を追加
// });

/////////////////////////////////////
/// SIDEBAR表示トリガー
/////////////////////////////////////
// $('.sidebar-toggle').on('click', function() {
//   $('body').toggleClass('is-sidemenu');
// })
// $(document).on("click", function(event) {
//   if (!$(event.target).closest("#sidebar").length && !$(event.target).is(".sidebar-toggle")) {
//     $('body').removeClass('is-sidemenu');
//   }
// });
//////////////////////
//スクロース中はSIDE NAVを隠す挙動
//////////////////////
// var timeoutId;
// window.addEventListener("scroll", function() {
//     clearTimeout(timeoutId);
//     $("#side-nav").toggleClass("is_scrollstop", $(window).scrollTop() >= 200);
//     timeoutId = setTimeout(function() {
//         // スクロール停止後の処理
//         // ここに何か追加する場合はここに記述
//     }, 300);
// });
// 別の要素をクリックで閉じる
// $(document).on('click touchend', function(e) {
//     if (!$(e.target).closest('#nav-content').length) {
//         $("#side-nav").removeClass("is_slidein"); // 修正
//     }
// });

var isScrolling = false;
var timeoutId;
function addScrollStopClass() {
  $("body").addClass("is_scrolling");
}
function removeScrollStopClass() {
  $("body").removeClass("is_scrolling");
}
window.addEventListener("scroll", function() {
  clearTimeout(timeoutId);
  removeScrollStopClass();
  timeoutId = setTimeout(function() {
    addScrollStopClass();
    // スクロール停止後の処理
    // ここに何か追加する場合はここに記述
  }, 300);
});
// スクロール中にも `is_scrolling` クラスを外す
$(window).on("scroll", function() {
  clearTimeout(timeoutId);
  addScrollStopClass();
  timeoutId = setTimeout(function() {
    removeScrollStopClass();
  }, 300);
});
/* ==================
SP BUGER MENU
===================== */
// $('#global_burgermenu > button').on('click', function() {
//   $(this).toggleClass('active');
//   if($(this).hasClass('active')){
//       $('body').addClass('is-sp-menu').removeClass('is-sp-menu-close');
//   }else{
//       $('body').removeClass('is-sp-menu').addClass('is-sp-menu-close');
//       $('#global-sp-menu').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
//         $('body').removeClass('is-sp-menu-close');
//       });
//     }
// });


/* ==================
SP BUGER MENU
===================== */
// $('.btn-jsopen-modal-form').on('click', function() {
//   $('body').addClass('is-modal-form00').removeClass('is-sp-menu-close');
//   $('#Modal-form00').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
//    function() {
//     // $('body').removeClass('is-sp-menu').addClass('is-sp-menu-close');
//     // $('body').removeClass('is-sp-menu-close');
//   });
// });


// click: マウスの左ボタンで要素がクリックされたとき。
// dblclick: マウスの左ボタンで要素がダブルクリックされたとき。
// mousedown: マウスのボタンが要素上で押されたとき。
// mouseup: マウスのボタンが要素上で離されたとき。
// mousemove: マウスが要素上で移動したとき。
// Touch Events (タッチイベント):

// touchstart: タッチが画面上で始まったとき。
// touchmove: タッチが画面上で移動したとき。
// touchend: タッチが画面上で終わったとき。
// touchcancel: タッチがキャンセルされたとき。
// Keyboard Events (キーボードイベント):

// keydown: キーが押されたとき。
// keyup: キーが離されたとき。
// keypress: 文字が入力されたとき。
// Focus Events (フォーカスイベント):

// focus: 要素がフォーカスを受け取ったとき。
// blur: 要素がフォーカスを失ったとき。
// Window Events (ウィンドウイベント):

// resize: ウィンドウのサイズが変更されたとき。
// scroll: ページがスクロールされたとき。


//RESIZE用イベント（Swiper,muuri用）
function triggerResizeEvent() {
  var event = document.createEvent('Event');
  event.initEvent('resize', true, true);
  window.dispatchEvent(event);
}

/* ==================
SIDE MENU
===================== */
$('#glb_side_menu').on({
  'mouseenter': function() {
    $('body').addClass('is-sidemenu-hover');
  },
  'mouseleave': function() {
    $('body').removeClass('is-sidemenu-hover');
  }
});
var menuVisible = false; 
var fixedVisible = false;
$('#glb_side_menu').on('click', function() {
  if (!menuVisible && !fixedVisible) { 
      $('body').addClass('is_side_menu');
      menuVisible = true; 
  }
});
$('#wrapper-contents').on('mouseenter mouseover click touchend', function() {
  $('body').removeClass('is_side_menu');
  menuVisible = false; 
});


$('#btn_side_fixed').on('click touchend', function() {
  if (!fixedVisible) { 
    $('body').addClass('is_side_menu_fixed is_side_menu');
    $('#btn_side_fixed').addClass('active');
    fixedVisible = true;
    menuVisible = false;
    triggerResizeEvent();
  }else{
    $('body').removeClass('is_side_menu_fixed is_side_menu');
    $('#btn_side_fixed').removeClass('active');
    fixedVisible = false;
    triggerResizeEvent();
  }
});

$('#global_burgermenu').on('click', function() {
  if (!menuVisible) { 
    $('body').addClass('is_side_menu');
  menuVisible = true; 
  triggerResizeEvent();
  }else{
    $('body').removeClass('is_side_menu_fixed is_side_menu');
    menuVisible = false;
    triggerResizeEvent();
  }
});






//////////////////////
//SIDE NAV (APP)
//////////////////////
// $("#nav-app").on({
//   "mouseenter click":function(){
//     $(this).addClass("is_slidein");
//   },
//   "mouseleave":function(){
//     $(this).removeClass("is_slidein");
//   },
//  });

/* ==================
SCROLL POSITION 
===================== */
// gsap.registerPlugin(ScrollTrigger);
var navLinks = document.querySelectorAll('#glb_side_menu nav a');
navLinks.forEach(function(link) {
    var targetHref = link.getAttribute('href');
    var sectionId = getHashFromUrl(targetHref);
    var targetSection = document.getElementById(sectionId);
    if (targetSection) {
        gsap.to(targetSection, {
            scrollTrigger: {
                trigger: targetSection,
                start: 'top center',
                end: 'bottom center',
                onToggle: function(self) {
                    // スクロールが発生したときにクラスを切り替える
                    link.closest('.pc_m').classList.toggle('js-this-position', self.isActive);
                },
                // markers: true // Optional: For debug purposes, you can enable markers
            }
        });
    }
});
/* ==================
SCROLL 
===================== */

function scrollToTarget(target) {
  gsap.to(window, {
      scrollTo: { y: target, autoKill: false },
      duration: 0.5, // 適切なドゥレーションを設定
      ease: "power2.inOut", // 適切なイージングを設定
      onComplete: function() {
          // アニメーション終了後に最終的なスクロール位置に調整
          window.scrollTo(0, target);
      },
  });
}

function getHashFromUrl(url) {
    var hashIndex = url.lastIndexOf('#');
    if (hashIndex !== -1) {
        return url.substring(hashIndex + 1);
    }
    return '';
}

function scrollToTarget(target) {
    gsap.to(window, {
        scrollTo: { y: target, autoKill: false },
        duration: 0,
        ease: "power2.in",
    });
}

// ページ読み込み時にハッシュがあればスクロール
window.onload = function() {
    if (window.location.hash) {
        var targetId = window.location.hash.substring(1); // # を取り除く
        var target = document.getElementById(targetId);
        if (target) {
            scrollToTarget(target.offsetTop);
        }
    }
};

// #で始まるアンカーリンクがクリックされたときにスクロール
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = link.getAttribute('href').substring(1); // # を取り除く
        var target = document.getElementById(targetId);
        if (target) {
            scrollToTarget(target.offsetTop);
        }
    });
});

/* ==================
SCROLL HEADER HEIGHT
===================== */
var headerH = $("#header").outerHeight(true); // headerの高さを取得
  function toggleHeaderClass() {
    $('body').toggleClass('is_scrollstart', $(window).scrollTop() >= headerH);
  }
  // 画面をスクロールしたら動かす
  $(window).scroll(toggleHeaderClass);
  // ページが読み込まれたらすぐに動かす
  $(window).on('load', toggleHeaderClass);


/* ==================
FANCYBOX
===================== */
  Fancybox.bind('[data-fancybox]', {
    hideScrollbar: false,
    // compact: false,
    // idle: false,
    // animated: false,
    // showClass: false,
    // hideClass: false,
    // dragToClose: false,
    // contentClick: false,
    Toolbar: {
    display: {
    left: [],
    middle: ['infobar'],
    right: ['close'],
    },
    },
    Thumbs: {
    type: 'classic',
    },
    });


//////////////////////////////////
//GSA ANMATION
//////////////////////////////////
/*右から移動*/
  gsap.utils.toArray('.am-x-r').forEach( (elm, index) => {
    gsap.from(elm,
      { x: 100,
        autoAlpha: 0 ,
        duration:1.5,
        opacity: 0,
        ease: "power2.out",
       scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
      });
  });
  
    
    /*左から移動*/
  gsap.utils.toArray('.am-x-l').forEach( (elm, index) => {
    gsap.from(elm,
      { x: -100,
        autoAlpha: 0 ,
        duration:1.5,
        opacity: 1,
        ease: "power2.out",
       stagger: 1.02,
       scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
      });
  });
    
    /*上から移動*/
  gsap.utils.toArray('.am-y-t').forEach( (elm, index) => {
    gsap.from(elm,
      { y: -100,
        autoAlpha: 0 ,
       duration:1.5,
        opacity: 1,
        ease: "power2.out",
        stagger:{
          from: "start", //左から
          amount: 0.8 // 0.8秒おき
        },
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', 
          end: 'bottom bottom',
          scrub: 1,
          // markers: true
          },
      });
  });
    /*下から移動*/
  gsap.utils.toArray('.am-y-b').forEach( (elm, index) => {
    gsap.from(elm,
     { y: 100,
        autoAlpha: 0 ,
       duration:1.5,
        opacity: 1,
        ease: "power2.out",
        stagger:{
          each:.5,
          ease: "power4.out",
          from: "start", //左から
          amount: 3.8 // 0.8秒おき
        },
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', 
          end: 'bottom bottom',
          scrub: 1,
          // markers: true
          },
      });
    });
  
  
  /*中央からスケール*/
  gsap.utils.toArray('.am-s-0').forEach( (elm, index) => {
  gsap.from(elm,
    { scaleX: .5,
      duration:1.5,
      opacity: 0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
    });
  });
  

/////////////////////////////////
    /*画像パララックス*/
/////////////////////////////////
//TOP PAGE MV
    // gsap.from("#an-tit1", {
    //   x:-100,
    //   opacity: 1,
    //   ease: "power2.out",
    // });

    gsap.set('.mv-txt00', {
      x: -300,
      y: 0,
      scale: 0,
      opacity: 0,
    });
  ///////////////////////////////////////////////////////
    var initialAnimationComplete = false;
    // GSAP Animation
    var animation = gsap.fromTo('.mv-txt00', {
      x: -300,
      y: 0,
      scale: 0,
      opacity: 0,
    }, {
      x: 0,
      y: 0,
      scale: 1,
      opacity: 1,
      duration: .5,
      // paused: true // アニメーションを最初は一時停止
    });


    
    // Click event to trigger animation
    $('#btn-mv-slide1').on("click",function() {
      // ボタンがクリックされたときにアニメーションを再生
      animation.play();
    });

    // ページがロードされたときの処理
    $(document).ready(function() {
      // 初回のみアニメーションを再生
      if (!initialAnimationComplete) {
        animation.play();
        initialAnimationComplete = true;
      }
    });
  ///////////////////////////////////////////////////////
    gsap.fromTo("#an-tit2", .5,
    {
      x: -100,
      y: 0,
      scale:0,
      opacity: 0,
    },
    // x, y 100px移動した状態で終了
    {
      x: 0,
      y: 0,
      scale:1,
      opacity: 1,
    }
  )

    // gsap.from("#an-stit", {
    //   x:-1000,
    //   y: -1000,
    //   rotation: -240,
    //   opacity: 0,
    //   delay: 2,
    //   duration: 1,
    //   scale:10,
    //   ease: "power2.out",
    // });

    // gsap.from("#char2 .char", {
    //   y:-500,
    //   x:-500,
    //   scale:0,
    //   rotation: 180,
    //   stagger: .05,
    //   opacity: 0,
    //   delay: 2.2,
    //   duration: 0.6,
    //   ease: "power2.out",
    // });





    // const lines = document.querySelectorAll('#section-cominfo tbl-001 .line');

    // // 各要素に対してアニメーションを設定
    // lines.forEach((line, index) => {
    //   // ScrollTriggerを使ってアニメーションを設定
    //   gsap.to(line, {
    //     width: '100%', // 線の長さ
    //     duration: 0.5, // アニメーション時間
    //     scrollTrigger: {
    //       trigger: '#section-cominfo',
    //       start: 'top center+=100', // トリガーの開始位置
    //       end: 'top center+=200', // トリガーの終了位置
    //       // markers: true, // マーカーを表示（デバッグ用）
    //       // onEnter: () => console.log('enter'), // トリガーに入ったときの処理
    //       // onEnterBack: () => console.log('enter back'), // トリガーに戻ったときの処理
    //     }
    //   });
    // });

///////////////////////
//AJAX ZIP
// イベントハンドラを定義
///////////////////////
function handleAjaxZip3() {
AjaxZip3.zip2addr('postal_code1', '', 'prefectures', 'address1');

// 成功時に実行する処理
AjaxZip3.onSuccess = function() {
    $('#address1').focus(); // 正しいIDを指定する必要があります
};

// 失敗時に実行する処理
AjaxZip3.onFailure = function() {
    alert('郵便番号に該当する住所が見つかりません');
};
}
// クリックイベントに対する処理
$('.ajaxzip3').on('click', function() {
  handleAjaxZip3();
  return false;
});

// Keyupイベントに対する処理
$('#postal_code1').on('keyup', function() {
  handleAjaxZip3();
});

///////////////////////////////
/// TEXTAREA AUTOHEIGHT
/////////////////////////////////
$('.js-autoheight').on('input', function(){
  this.style.height = 'auto';
  this.style.height = (this.scrollHeight) + 'px';
});
////////////////////////
//FORM COPY
////////////////////////
    // モーダルが開かれる瞬間に発生するイベント
    $('#Modal-form00').on('show.bs.modal', function () {
      var formAContent = $('#formA .fm-contact00').clone(true);
      $('#formB').empty().append(formAContent);
      $('#formA').empty();
      // $(document).on('click', '.submit-ajax', function() {
      //     alert("dd");
      // });
  });
  // モーダルが閉じられる瞬間に発生するイベント
  $('#Modal-form00').on('hidden.bs.modal', function () {
      var formBContent = $('#formB .fm-contact00').clone(true);
      $('#formA').empty().append(formBContent);
      $('#formB').empty();
  });
/////////////////////////
///AKAX POST
//////////////////////////
// $('.submit-ajax').on('click',function() {//非同期でつくられてなければこれでOK
$(document).on('click', '.submit-ajax', function() {
var $myform = $(this).closest("form");
var form_id = $myform.attr("id");
  $.ajax({
  url: '/contact_com.php',
  type: 'post',
  data: $myform.serialize(),
  dataType: 'json',  // 追加
    success: function(response) {
    $(".error").empty();
    console.log(response);
      if (response.errors) {
      var errors = response.errors;
      for (var key in errors) {
      var errorSelector = '#error_' + key;
      $(errorSelector).html(errors[key]);
      console.log(errorSelector + "です");
      }
      }else if (response.success) {
        // 成功したら/contact_com_done.phpにリダイレクト
        window.location.href = '/contact_com_done.php';
      }
    },
    error: function(error) {
    console.log('Error:', error);
    }
  });
});



/////////////////////////////////////////////
//TOOL TIPS (no HOVER but CLICK)
/////////////////////////////////////////////
// $('[data-bs-toggle="tooltip"]').tooltip();


/////////////////////////////////////////////
//DEV
/////////////////////////////////////////////
$(".dev-bg i").on("click", function(e) {
  e.preventDefault();
  var classNum = $(this).data("bg");
  $(this).closest(".mvimg").removeClass(function(index, className) {
  return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
  }).addClass("mv-" + classNum);
  });
  
  $('[data-js="add_hover"]').hover(function() {
  $(this).closest('.mvimg').addClass('is_hover');
  }, function() {
  $(this).closest('.mvimg').removeClass('is_hover');
  });


//////////////////////////////////////////////
  // var originalClasses = {}; // オリジナルのクラスを保持する連想配列
  // // ページ読み込み時に.dev-bgの数を調べ、originalClassesを初期化
  // $(".dev-bg").each(function(index) {
  //   var mvimgElement = $(this).closest(".mvimg");
  //   var originalClass = mvimgElement.attr("class").match(/mv-\d+/)[0]; // mv-(number)のクラスを取得

  //   // idがない場合は"DEV_{originalClass}"の名前のIDを付与
  //   var sectionId = mvimgElement.attr("id") || `DEV_${originalClass}`;
  //   mvimgElement.attr("id", sectionId); // IDを付与

  //   var classNum = $(this).find("i").data("bg"); // 子要素のiからdata-bgの値を取得
  //   var originalClassLastDigits = originalClass.slice(-3); // originalClassの下3桁の数字を取得
  //   $(this).closest(".mvimg").find("i[data-bg=" + originalClassLastDigits + "]").addClass("bg-selected");//originalClassででもいい
 
  //   originalClasses[sectionId] = originalClass;
  // });
  
  // $(".dev-bg i").on("mouseenter mouseleave click", function(e) {
  //   e.preventDefault();
  //   var sectionId = $(this).closest(".mvimg").attr("id"); // .mvimgのidを取得
  //   var originalClass = originalClasses[sectionId];
  //   var classNum = $(this).data("bg");
  //   var mvimg = $(this).closest(".mvimg");
  
  //   // すべてのmv-(number)クラスを削除
  //   mvimg.removeClass(function(index, className) {
  //     return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
  //   });
  
  //   if (e.type === "mouseenter" || (e.type === "click" && !$(this).hasClass("active"))) {
  //     // 他のmv-(number)クラスを削除してから追加
  //     mvimg.addClass("mv-" + classNum);
  //   }
  
  //   if (e.type === "click") {
  //     // click イベントが発生したときに active クラスを付与
  //     $(this).addClass("active");
  //     originalClasses[sectionId] = "mv-" + classNum;
  //   } else if (e.type === "mouseleave" && !$(this).hasClass("active")) {
  //     // click イベントが発生していない場合のみ originalClass を親に追加
  //     mvimg.addClass(originalClass);
  //   }
  
  //   console.log(originalClasses); // originalClassesの値をコンソールに出力
  // });


/////////////////////////////////////////////
//DEV TARGET KILL
/////////////////////////////////////////////

$(".kill").on("click", function() {
  if (confirm("本当に削除しますか？")) {
      $(this).closest(".targetkill").hide();
  }
});





/////////////////////////////////////////////
//言語判定
/////////////////////////////////////////////
// ブラウザの言語を取得
var browserLanguage = navigator.language || navigator.userLanguage;
// 取得した言語をコンソールに表示
console.log('Browser Language:', browserLanguage);

// もし言語が英語かタガログ語であれば何か特定の処理を実行
if (browserLanguage.startsWith('en')) {
  // 英語の場合の処理
  console.log('English Language Detected');
} else if (browserLanguage.startsWith('tl')) {
  // タガログ語の場合の処理
  console.log('Tagalog Language Detected');
} else {
  // それ以外の言語の場合の処理
  console.log('Other Language Detected');
}


});


